const processDefaultEntity = (feedBlock) => ({
  label: feedBlock.label || feedBlock.extraBlockInfo.label || '',
  type: feedBlock.type,
  extraBlockinfo: {
    ...(feedBlock.extraBlockInfo || {})
  }
});

export default processDefaultEntity;
